import type { Business } from "@/lib/types";
import React, { useMemo } from "react";
import { Pressable, Text, View } from "react-native";

function normalizeSubCategory(value: unknown): string[] {
  if (Array.isArray(value)) return value.map((s) => String(s || "").trim()).filter(Boolean);
  if (typeof value === "string") {
    const t = value.trim();
    return t ? [t] : [];
  }
  return [];
}

export default function DesktopSidebar({ business }: { business: Business }) {
  const category = String((business as any).category || "").trim();
  const sub = useMemo(() => normalizeSubCategory((business as any).subCategory), [business]);

  return (
    <View style={styles.wrap}>
      <Text style={styles.title}>Category</Text>

      <View style={styles.section}>
        <Text style={styles.pillMain}>{category || "—"}</Text>
      </View>

      <Text style={[styles.title, { marginTop: 14 }]}>Subcategories</Text>
      <View style={styles.section}>
        {sub.length ? (
          sub.map((s, i) => (
            <Pressable key={`${s}-${i}`} style={styles.pill}>
              <Text style={styles.pillText}>{s}</Text>
            </Pressable>
          ))
        ) : (
          <Text style={styles.muted}>No subcategories</Text>
        )}
      </View>

      <View style={styles.hr} />

      <Text style={styles.note}>
        Tip: Later you can add filters here (location, price range, open now, etc).
      </Text>
    </View>
  );
}

const styles: any = {
  wrap: {
    borderRadius: 18,
    borderWidth: 1,
    borderColor: "#e5e7eb",
    backgroundColor: "#fff",
    padding: 14,
  },
  title: { fontSize: 12, fontWeight: "900", color: "#111827" },
  section: { marginTop: 10, flexDirection: "row", flexWrap: "wrap" },
  pillMain: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 999,
    backgroundColor: "#eff6ff",
    borderWidth: 1,
    borderColor: "#bfdbfe",
    fontWeight: "900",
    color: "#1d4ed8",
  },
  pill: {
    paddingVertical: 8,
    paddingHorizontal: 12,
    borderRadius: 999,
    backgroundColor: "#f3f4f6",
    borderWidth: 1,
    borderColor: "#e5e7eb",
    marginRight: 8,
    marginBottom: 8,
  },
  pillText: { fontSize: 12, fontWeight: "800", color: "#111827" },
  muted: { fontSize: 12, color: "#6b7280", fontWeight: "700" },
  hr: { height: 1, backgroundColor: "#eef2f7", marginTop: 14, marginBottom: 12 },
  note: { fontSize: 11, color: "#6b7280", fontWeight: "700", lineHeight: 16 },
};
